export const common = {
  // Navigation
  'nav.features': '功能',
  'nav.howItWorks': '工作原理',
  'nav.pricing': '价格',
  'nav.faq': '常见问题',
  'nav.aboutUs': '关于我们',
  'nav.getStarted': '开始使用',

  // About Us Section
  'aboutUs.badge': '关于我们',
  'aboutUs.title': '关于我们',
  'aboutUs.line1': '想法很廉价。',
  'aboutUs.line2': '资本不是。时间更不是。',
  'aboutUs.paragraph1': 'IdeaOracle.ai的创立是因为大多数商业想法的失败不是因为缺乏勇气——而是因为缺乏诚实。太多的肯定。太少的现实。',
  'aboutUs.belief1a': '我们不相信炒作。',
  'aboutUs.belief1b': '我们相信市场逻辑。',
  'aboutUs.belief2a': '我们不相信激励。',
  'aboutUs.belief2b': '我们相信需求、竞争和差异化。',
  'aboutUs.mission1': '我们的任务不是让想法看起来好。',
  'aboutUs.mission2': '我们的任务是揭示它们的可行性。',
  'aboutUs.analysis': 'IdeaOracle.ai分析商业利基的结构性市场机制、现实需求、竞争强度和可行性。不感情用事。不盲目乐观。而是冷静客观。',
  'aboutUs.failure1': '大多数想法都会失败。',
  'aboutUs.failure2': '不是因为创始人无能——',
  'aboutUs.failure3': '而是因为事先没有人足够清晰。',
  'aboutUs.clarity': '我们的存在就是为了提供这种清晰。',
  'aboutUs.value1': '令人不适。',
  'aboutUs.value2': '直接。',
  'aboutUs.value3': '始终如一。',
  'aboutUs.confirm': '如果一个想法有实质，我们会确认。',
  'aboutUs.deny': '如果没有，我们也会说出来。',
  'aboutUs.noApplause': '没有掌声。',
  'aboutUs.noSugarcoating': '没有粉饰。',
  'aboutUs.noTheater': '没有做戏。',

  // Hero Section
  'hero.badge': '商业利基决策AI',
  'hero.title1': '想法很便宜。',
  'hero.title2': '错误的决定不便宜。',
  'hero.subtitle': '在您投资之前',
  'hero.subtitleLine2': '评估您的商业利基的AI。',
  'hero.cta': '检查想法',
  'hero.ctaSecondary': '工作原理',
  'hero.stat1Value': '30',
  'hero.stat1Label': '每次请求的积分',
  'hero.stat2Value': '7+',
  'hero.stat2Label': '评级级别',
  'hero.stat3Value': '100%',
  'hero.stat3Label': '诚实且私密',

  // Features Section
  'features.title1': '强大的功能',
  'features.title2': '现代',
  'features.title3': '企业',
  'features.honestVerdict.title': '诚实评判，而非吹捧分数',
  'features.honestVerdict.description': '基于真实市场数据和竞争对手研究的好/中/差直接评判。没有为讨好每个想法而设的 9/10 分。',
  'features.fullJourney.title': '从想法验证到 Builder Report',
  'features.fullJourney.description': '在聊天中验证，深入市场分析，导出 25–75 页 Builder Report，含 personas、财务、市场进入和 pitch deck。',
  'features.multilingual.title': '21 种语言，本地市场数据',
  'features.multilingual.description': '从瑞士中小企业到圣保罗的独立创业者 — AI 用你的语言作答，引用你所在市场的来源。',

  // How It Works
  'howItWorks.title': '工作原理',
  'howItWorks.subtitle': '四步了解您的商业利基。',
  'howItWorks.step1Title': '选择计划',
  'howItWorks.step1Desc': 'Starter、Pro或Builder - 取决于您审查的深度。',
  'howItWorks.step2Title': '询问AI',
  'howItWorks.step2Desc': '提出关于利基的问题。每次请求花费30积分。',
  'howItWorks.step3Title': '获得诚实的评价',
  'howItWorks.step3Desc': 'AI评级：好、中等或差。不加修饰。',
  'howItWorks.step4Title': '做出决定',
  'howItWorks.step4Desc': '现在您知道是否值得继续前进。',

  // Pricing
  'pricing.title': '价格',
  'pricing.subtitle': '选择适合您审查深度的计划。',
  'pricing.yearlyDiscount': '年度订阅：',
  'pricing.yearlyDiscountValue': '-20%折扣',
  'pricing.perMonth': '每月',
  'pricing.selectPlan': '选择计划',
  'pricing.mostPopular': '最受欢迎',
  'pricing.footer': '所有价格均为瑞士法郎。积分仅在AI成功响应时扣除。',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': '用于初步现实测试。',
  'pricing.starter.credits': '2,500积分',
  'pricing.starter.feature1': '生成利基想法',
  'pricing.starter.feature2': '完善利基',
  'pricing.starter.feature3': '市场现实检查',
  'pricing.starter.feature4': '竞争评估',
  'pricing.starter.feature5': '时机评估',
  'pricing.starter.feature6': '诚实的评价',
  'pricing.starter.feature7': '私人会话',
  'pricing.starter.feature8': '历史记录和导出',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': '用于更深入的审查。',
  'pricing.pro.credits': '5,000积分',
  'pricing.pro.feature1': '所有Starter功能',
  'pricing.pro.feature2': '更多积分用于深入审查',
  'pricing.pro.feature3': '改进建议',
  'pricing.pro.feature4': '替代利基',
  'pricing.pro.feature5': '详细的市场分析',
  'pricing.pro.feature6': '优先支持',
  'pricing.pro.feature7': '高级过滤器',
  'pricing.pro.feature8': '会话收藏',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': '想法 → 开发者简报。',
  'pricing.builder.credits': '无限积分',
  'pricing.builder.feature1': '所有Pro功能',
  'pricing.builder.feature2': '无限AI请求',
  'pricing.builder.feature3': 'Builder模式：开发者简报',
  'pricing.builder.feature4': '结构化项目概述',
  'pricing.builder.feature5': '用户流程和核心功能',
  'pricing.builder.feature6': '技术说明',
  'pricing.builder.feature7': '定义非目标',
  'pricing.builder.feature8': '公平使用速率限制',
  'pricing.builder.limitNote': '公平使用限制',
  'pricing.monthlyReset': '每月重置',

  // Modal
  'pricing.modal.selected': '已选择',
  'pricing.modal.comingSoon': '注册和支付处理即将推出。',
  'pricing.modal.patience': '我们正在努力为您提供安全无缝的体验。请耐心等待。',
  'pricing.modal.understood': '明白了',

  // FAQ
  'faq.title': '常见问题',
  'faq.subtitle': '诚实且批判性地回答。',
  'faq.q1': 'IdeaOracle.ai具体做什么？',
  'faq.a1': 'IdeaOracle.ai从市场逻辑、真实需求、竞争、差异化和可行性方面评估商业想法和利基。\n如果有实质，我们展示如何在战略上加以完善。\n如果没有，我们会说出来。',
  'faq.q2': '你们也生成想法吗？',
  'faq.a2': '是的。\n但不是盲目的。\n我们基于市场逻辑开发方法——而非动机或趋势炒作。',
  'faq.q3': '你们优化商业模式吗？',
  'faq.a3': '是的——如果有潜力。\n我们不打磨幻想。\n我们让可行的概念更加坚韧。',
  'faq.q4': '你们与其他AI工具有什么不同？',
  'faq.a4': '其他工具提供灵感。\n我们提供评估。\n重点在于现实主义，而非热情。',
  'faq.q5': '这是成功的保证吗？',
  'faq.a5': '不是。\n我们减少错误决策——我们不消除风险。',
  'faq.q6': 'IdeaOracle.ai适合谁？',
  'faq.a6': '启动前的创始人\n扩张前的企业家\n时间投入前的副业建设者\n审查前的投资者\n\n简而言之：为那些在资本之前想要清晰的人。',
  'faq.q7': '如果我只是寻求确认呢？',
  'faq.a7': '那么IdeaOracle.ai不是合适的工具。',
  'faq.q8': '分析有多诚实？',
  'faq.a8': '在数据和市场机制允许的范围内尽可能诚实。\n没有狂热。没有留情。',
  'faq.q9': '你们替代市场研究吗？',
  'faq.a9': '不。\n我们是战略性的预评估——不是完整的市场研究。',
  'faq.q10': '为什么如此不妥协？',
  'faq.a10': '因为失败代价高昂。\n诚实则不然。',

  // Footer
  'footer.description': '这个平台不是帮助你感觉良好 - 而是帮助你做出正确的决定。',
  'footer.product': '产品',
  'footer.aiAssistant': 'AI助手',
  'footer.howItWorks': '工作原理',
  'footer.pricing': '价格',
  'footer.faq': '常见问题',
  'footer.legal': '法律',
  'footer.privacy': '隐私',
  'footer.terms': '条款',
  'footer.imprint': '版权信息',
  'footer.support': '支持',
  'footer.contact': '联系',
  'footer.documentation': '文档',
  'footer.copyright': '© 2025 IdeaOracle.ai. 保留所有权利。',

  // AI Assistant
  'aiAssistant.title': 'AI利基助手',
  'aiAssistant.subtitle': '关于利基的问题',
  'aiAssistant.welcomeMessage': '你好！描述你的想法或向我询问利基。我会给你一个清晰诚实的评估。',
  'aiAssistant.demoResponse': '这是演示。要获得真实的AI评估，请注册并选择计划。',
  'aiAssistant.placeholder': '描述你的想法...',

  // Header & Sidebar
  'dashboard.header.title': '仪表板',
  'dashboard.sidebar.overview': '概览',
  'dashboard.sidebar.newAnalysis': 'AI助手',
  'dashboard.sidebar.history': '历史',
  'dashboard.sidebar.credits': '积分',
  'dashboard.sidebar.settings': '设置',

  // Dashboard Overview
  'dashboard.overview.welcome': '欢迎回来，{{name}}',
  'dashboard.overview.subtitle': '这是您活动的快速概览',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': '剩余积分',
  'dashboard.stats.totalAnalyses': '总分析数',
  'dashboard.stats.goodRatings': '正面评价',
  'dashboard.stats.nextReset': '下次重置',
  'dashboard.stats.days': '天',

  // Quick Actions
  'dashboard.quickActions.title': '快速操作',
  'dashboard.quickActions.checkNewIdea': '检查想法',
  'dashboard.quickActions.checkNewIdeaDesc': '分析现有商业想法',
  'dashboard.quickActions.generateIdea': '生成想法',
  'dashboard.quickActions.generateIdeaDesc': '找到新的盈利利基',
  'dashboard.quickActions.builderBriefing': 'Builder简报',
  'dashboard.quickActions.builderBriefingDesc': '将想法转化为开发者就绪的简报',
  'dashboard.quickActions.premiumOnly': '仅限Builder',

  // Chat Header
  'chat.title': 'AI利基助手',
  'chat.subtitle': '询问关于利基的问题。我会批判性和诚实地评估。',
  'chat.creditsLabel': '积分',

  // Chat Welcome
  'chat.welcomeTitle': '欢迎使用AI利基助手',
  'chat.welcomeDesc': '描述你的想法或询问利基。我会诚实地评估：好、中等或差。',
  'chat.aiWelcome': '你好！描述你的想法或向我询问利基。我会给你一个清晰诚实的评估。',

  // Chat Suggestions
  'chat.suggestion1': '为我找一个盈利的利基。',
  'chat.suggestion2': '我有一个想法 - 诚实地评估它。',
  'chat.suggestion3': '现在哪些利基有潜力？',
  'chat.suggestion4': '完善这个利基并使其更具体。',

  // Chat Actions
  'chat.newConversation': '新对话',
  'chat.today': '今天',
  'chat.yesterday': '昨天',
  'chat.thisWeek': '本周',
  'chat.thisMonth': '本月',
  'chat.older': '更早',
  'chat.messages': '消息',
  'chat.renameConversation': '重命名',
  'chat.deleteConversation': '删除',
  'chat.cancel': '取消',
  'chat.rename': '重命名',
  'chat.delete': '删除',
  'chat.favorite': '添加收藏',
  'chat.unfavorite': '取消收藏',
  'chat.searchSessions': '搜索对话...',
  'chat.noResults': '未找到结果',
  'chat.noSessions': '还没有对话',
  'chat.enterNewName': '输入新名称...',
  'chat.deleteConfirmMessage': '您确定要删除此对话吗？此操作无法撤消。',

  // Chat Input & Errors
  'chat.inputPlaceholder': '输入您的问题…（花费30积分）',
  'chat.send': '发送',
  'chat.voice': '说话',
  'chat.listeningPlaceholder': '我在听...现在说话。',
  'chat.stopListening': '停止录音',
  'chat.recording': '录音中...',
  'chat.speechNotSupported': '您的浏览器不支持语音识别。',
  'chat.microphonePermissionDenied': '麦克风访问被拒绝。请在浏览器设置中允许访问。',
  'chat.errorNotEnoughCredits': '积分不足。请升级您的计划或等待下次重置。',
  'chat.errorAiFailed': 'AI响应失败。未扣除积分。',
  'chat.errorRateLimit': '请求过多。请稍等片刻。',

  // Ratings
  'rating.good': '好',
  'rating.medium': '中等',
  'rating.bad': '差',

  // Auth Page
  'auth.branding.headline1': '并非每个想法都是好的。',
  'auth.branding.headline2': '我们会诚实地告诉你。',
  'auth.branding.subtitle': '商业利基决策AI。清晰。批判。不加修饰。',
  'auth.benefits.privacy.title': '100% 私密',
  'auth.benefits.privacy.desc': '您的想法完全私密且安全。',
  'auth.benefits.honest.title': '诚实的AI',
  'auth.benefits.honest.desc': '不加修饰 – 只有清晰、批判性的反馈。',
  'auth.benefits.fast.title': '快速结果',
  'auth.benefits.fast.desc': '几分钟内获得关于您利基的清晰度。',
  'auth.trust.users': '活跃用户',
  'auth.trust.ideas': '已分析的想法',
  'auth.trust.rating': '评分',
  'auth.login.title': '登录',
  'auth.login.headline': '欢迎回来',
  'auth.login.subtitle': '登录以继续您的旅程。',
  'auth.login.forgotPassword': '忘记密码？',
  'auth.login.submit': '登录',
  'auth.login.noAccount': '还没有账户？',
  'auth.login.signUp': '注册',
  'auth.register.title': '注册',
  'auth.register.headline': '创建您的账户',
  'auth.register.subtitle': '今天开始分析您的商业想法。',
  'auth.register.submit': '创建账户',
  'auth.register.hasAccount': '已有账户？',
  'auth.register.signIn': '登录',
  'auth.fields.name': '姓名',
  'auth.fields.email': '电子邮件地址',
  'auth.fields.password': '密码',
  'auth.fields.confirmPassword': '确认密码',
  'auth.fields.selectPlan': '选择您的计划',
  'auth.placeholders.name': '输入您的姓名',
  'auth.placeholders.email': '输入您的电子邮件',
  'auth.placeholders.password': '输入您的密码',
  'auth.placeholders.confirmPassword': '确认您的密码',
  'auth.terms.accept': '我同意',
  'auth.terms.terms': '条款和条件',
  'auth.privacy.accept': '我同意',
  'auth.privacy.policy': '隐私政策',
  'auth.errors.nameRequired': '姓名是必填项',
  'auth.errors.emailRequired': '电子邮件是必填项',
  'auth.errors.emailInvalid': '请输入有效的电子邮件',
  'auth.errors.passwordRequired': '密码是必填项',
  'auth.errors.passwordLength': '密码必须至少8个字符',
  'auth.errors.passwordMismatch': '密码不匹配',
  'auth.loading': '请稍候...',
  'auth.or': '或继续使用',
  'auth.social.google': '使用Google继续',
  'auth.social.apple': '使用Apple继续',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3天免费试用',
  'pricing.trial.credits': '250积分',
  'pricing.trial.free': '免费',
  'pricing.trial.duration': '3天免费',
  'pricing.trial.cta': '开始免费试用',
  'pricing.trial.feature1': '250积分用于探索AI',
  'pricing.trial.feature2': '3天完整访问权限',
  'pricing.trial.feature3': '无需信用卡',
  'pricing.trial.feature4': '随时取消',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000积分 + 25页Builder报告',
  'pricing.gold.credits': '10,000积分',
  'pricing.gold.feature1': '10,000积分',
  'pricing.gold.feature2': '25页Builder报告',
  'pricing.gold.feature3': '所有Starter和Pro功能',
  'pricing.gold.feature4': '市场分析与摘要',
  'pricing.gold.feature5': '机会、风险、建议',
  'pricing.gold.feature6': '下载PDF',
  'pricing.gold.feature7': '支持',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000积分 + 100页Builder报告',
  'pricing.platinum.credits': '15,000积分',
  'pricing.platinum.feature1': '15,000积分',
  'pricing.platinum.feature2': '100页Builder报告',
  'pricing.platinum.feature3': '所有Gold功能',
  'pricing.platinum.feature4': 'Builder模式:开发者简报',
  'pricing.platinum.feature5': '结构化摘要',
  'pricing.platinum.feature6': '高级市场分析',
  'pricing.platinum.feature7': '支持',

  // Pricing UI
  'pricing.monthly': '按月',
  'pricing.yearly': '按年',
  'pricing.savings': '节省',
  'pricing.billedYearly': '按年结算',

  // Hero trial CTA
  'hero.trialTitle': '开始免费试用',
  'hero.creditsLabel': '积分',
  'hero.trialTagline': '免费试用我们的AI助手3天',
  'hero.trialCta': '注册并获得250积分',
  'hero.trialNoCard': '无需信用卡。无需承诺。',

  // Admin
  'admin.dashboard.tabs.plans': '方案',

  // Credit top-up
  'dashboard.credits.topup.button': '充值积分',
  'dashboard.credits.topup.buttonTitle': '无需更换方案即可购买更多积分',
  'dashboard.credits.topup.title': '充值积分',
  'dashboard.credits.topup.subtitle': '每积分CHF 0.15 — 无需更换方案',
  'dashboard.credits.topup.quickAmounts': '快速选择',
  'dashboard.credits.topup.custom': '自定义',
  'dashboard.credits.topup.totalLabel': '总计',
  'dashboard.credits.topup.creditsLabel': '积分',
  'dashboard.credits.topup.confirm': '立即购买',
  'footer.disclaimer': '免责声明',
  'legal.backToHome': '返回首页',
  'legal.lastUpdated': '最后更新',
  'legal.allRightsReserved': '版权所有。',
  'legal.authoritativeNotice': '尚未提供您所选语言的本地化版本。以下显示具有法律效力的英文原文。',
  'legal.translationNotice': '这是一份便利译文。英文版本为具有法律约束力的正式版本。',
};

export default common;
